export default {"src":"/_next/static/media/accountIcon.a74bb46f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};